module.exports = __webpack_public_path__ + "img/c02-aerial.1d4de274.gif";